import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { PageService } from 'src/app/core/page/page.service';
import { ValidatorsService } from 'src/app/core/validators/validators.service';
import { selectActiveLanguage } from 'src/app/store/language/selectors';
import { AppStateInterface } from 'src/app/store/types';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { NgClass, NgIf, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { bootstrapFacebook, bootstrapInstagram, bootstrapMailbox, bootstrapTwitter } from '@ng-icons/bootstrap-icons';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        ReactiveFormsModule,
        NgIcon,
        NgClass,
        NgIf,
        RouterLink,
        AsyncPipe,
        TranslateModule,
    ],
    providers: [provideIcons({ bootstrapMailbox, bootstrapTwitter, bootstrapInstagram, bootstrapFacebook })]
})
export class FooterComponent {
  activeLanguage: string = '';
  currentYear = new Date().getFullYear().toString();

  invalidEmail:boolean = false;
  successfullySubscribed: BehaviorSubject<boolean> =  new BehaviorSubject<boolean>(false);

  subscriptionForm = new FormGroup({
    email: new FormControl(null, [Validators.required, this._validatorsService.emailPattern]),
  });

  constructor(
    private _pageService: PageService,
    private _store: Store<AppStateInterface>,
    private _validatorsService: ValidatorsService
  ) {}

  ngOnInit() {
    this._store.select(selectActiveLanguage).subscribe({
      next: (activeLanguage) => {
        this.activeLanguage = activeLanguage;
      },
    });
  }

  ngAfterViewInit() {
    this._pageService.setDirection(this.activeLanguage);
  }

  async onFormSubmit() {
    if(this.subscriptionForm.get('email')?.invalid){
      this.invalidEmail= true;
      return
    }
    const email = this.subscriptionForm.get('email')?.value;
    if(email){
      this._pageService.subscribe(email).subscribe({
        next: result => {
          this.successfullySubscribed.next(true);
          this.invalidEmail= false;
        },
        error: error => {
          console.log(error);
        }
      })
    }
  }
}
